
import React, { useState, useEffect , useRef} from "react";
import TradeDetails from "./TradeDetails"; // Replace with the correct path to your TradeDetails component
import { Radio } from "@material-tailwind/react";
import {socketServerURL, apiURL, token, DB_CONFIG} from './GlobalParameters.js';
import ProfitChart from './ProfitChart';
//const totalPointsRef = { current: 0 }; // Initialize the ref
//let totalPointsRef = {current: 0};

const DailyPlreport = (ipData) => {//debugger;
  const [tradeData, setTradeData] = useState([]);
  let [totalProfitLoss, setTotalProfitLoss] = useState(0);
  let [totalPoints, setTotalPoints] = useState(0), [totalTrades, setTotalTradeCount] = useState(0);
      let [positiveTrades, setPositiveTradeCount] = useState(0), [negativeTrades, setNegativeTradeCount] = useState(0);
      let [positiveGains, setPositiveGain] = useState(0), [negativeGains, setNegativeGain] = useState(0);;
  const [error, setError] = useState(null);
  const [showData, setShowData] = useState(true); // Set showData to true by default
  // [totalPointsRef] = useState({ current: 0 });
  let fromDate = ipData.ipData.fromDate, toDate = ipData.ipData.toDate, reportTypes = ipData.ipData.reportTypes, 
  selectedBox = ipData.ipData.selectedBox, Called = ipData.ipData.Called;

  useEffect(() => {
    // Function to fetch data from the Node.js endpoint
    const fetchTradeData = async () => {
      try {
        let response = {}, data = {};
        if (selectedBox == "BANK NIFTY") {
          if (fromDate && toDate && reportTypes && reportTypes.fixedMargin)
            response = await fetch(apiURL + 'fixmargin?fromDt=' + fromDate + '&toDt=' + toDate + '');//response = await fetch(apiURL + 'trendreport');
          else if (fromDate && toDate && reportTypes && reportTypes.fixedLot)
            response = await fetch(apiURL + 'fixlot?fromDt=' + fromDate + '&toDt=' + toDate + '');
          data = await response.json();
        }
        else if (selectedBox == "NIFTY") {
          if (fromDate && toDate && reportTypes && reportTypes.fixedMargin)
            response = await fetch(apiURL + 'trendreportNifty50?fromDt=' + fromDate + '&toDt=' + toDate + '&reportType=fixmargin');//response = await fetch(apiURL + 'trendreport');
          else if (fromDate && toDate && reportTypes && reportTypes.fixedLot)
            response = await fetch(apiURL + 'trendreportNifty50?fromDt=' + fromDate + '&toDt=' + toDate + '&reportType=fixlot');
          data = await response.json();
        }
        
        if (!response.ok) {
          console.log('Failed to fetch service daily data');
          //throw new Error('Failed to fetch service data');
        }

        /*let total = 0, arrData = (data && data.success) ? data.data[0] : null, originalBalance = 100000;
        let totalPoints = 0;
        if (Array.isArray(arrData)) {
          arrData.forEach(function callback(item, index) {
            if (item && typeof item["PROFIT/LOSS"] === 'number') {
              total += item["PROFIT/LOSS"];
            }
            if (item && typeof item["POINTS GAIN"] === 'number') {
              totalPoints += item["POINTS GAIN"];
            }
            if (item && typeof item["CumulativeBALANCE"] === 'number') {
              if(index == 0)
                item["CumulativeBALANCE"] = originalBalance + item["CumulativeBALANCE"];
              else
                item["CumulativeBALANCE"] = item["CumulativeBALANCE"] + arrData[index - 1]["CumulativeBALANCE"];
            }
            if (item && typeof item["row_num"] === 'number') {
                item["row_num"] = index + 1;
             }
          });
        }*/
          let total = 0, arrData = (data && data.success) ? data.data[0] : null, arrLength = 0, originalBalance = 100000;
          let totalPoint = 0, positivetradecount = 0, negativetradecount = 0, positivegainpoints = 0, negativegainpoints = 0;
          if (Array.isArray(arrData)) {
            arrLength = arrData.length;
            arrData.forEach(function callback(item, index) {
              if (item && typeof item["PROFIT/LOSS"] === 'number') {
                total += item["PROFIT/LOSS"];
              }
              if (item && typeof item["POINTS GAIN"] === 'number') {
                totalPoint += item["POINTS GAIN"];
              }
              if (item && parseFloat(item["PROFIT/LOSS"]) >= 0) {
                positivetradecount++;
                positivegainpoints += parseFloat(item["PROFIT/LOSS"]);
              }
              if (item && parseFloat(item["PROFIT/LOSS"]) < 0) {
                negativetradecount++;
                negativegainpoints += Math.abs(parseFloat(item["PROFIT/LOSS"]));
              }
              if (item && typeof item["CumulativeBALANCE"] === 'number') {
                if(index == 0)
                  item["CumulativeBALANCE"] = originalBalance + item["CumulativeBALANCE"];
                else
                  item["CumulativeBALANCE"] = item["CumulativeBALANCE"] + arrData[index - 1]["CumulativeBALANCE"];
              }
              if (item && typeof item["row_num"] === 'number') {
                  item["row_num"] = index + 1;
              }
            });
          }
        setTradeData(arrData);
        
        /*setTotalPoints(totalPoint);
        setTotalProfitLoss(total);
       // tempVal(totalPoints);
        //totalPointsRef.current = totalPoints;
        setPositiveTradeCount(positivetradecount);
            setNegativeTradeCount(negativetradecount); 
            setTotalTradeCount(arrLength);   
            setPositiveGain(positivegainpoints);
            setNegativeGain(negativegainpoints);*/
      } catch (err) {
console.log('Error inside '+err);
        setError(err.message);
      }
    };
console.log('Completed '+Called);
    // Call the fetch function
    if(Called)
      fetchTradeData();
  }, []); // Empty dependency array ensures the effect runs once when the component mounts

  return (
    <div className="mt-1 p-1  max-h-[50vh] overflow-y-auto">
    { !tradeData || tradeData.length == 0 ? <p className="text-gray-200 text-center">No records available.</p> : null}
      {showData && reportTypes.pnl && tradeData ? (
        <TradeDetails tradeData={tradeData} />
      ) : (
        <p></p>//Loading...
      )}
      { reportTypes.trend && tradeData ? ( <div> <ProfitChart data={tradeData} /> </div> ) : ( <p></p> ) }
    </div>
  );
};

export default DailyPlreport;
//export { totalPointsRef };
